export const HELP_HOW_MATCH = "/help/how-to-act"
export const HELP_WHY_MATCH = "/help/why-create-a-payment-schedule"
export const HELP_WHEREFORE_MATCH = "/help/why-deal-with-debt-immediately"
export const HELP_WHAT_MATCH = "/help/what-happens-if-i-dont-fulfill-my-debt"
